import { AbstractControl, ValidatorFn } from "@angular/forms";

export function requireIfValueIs(
  relatedControlName: string,
  requiredValue: any
): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.parent) {
      return null; // Parent form not ready yet
    }

    const relatedControl = control.parent.get(relatedControlName);
    if (!relatedControl) {
      return null; // Related control not found
    }

    // Check if related control's value matches requiredValue
    if (relatedControl.value === requiredValue) {
      // Then current control must have a value (not empty)
      return control.value ? null : { requiredIf: true };
    }

    return null;
  };
}